module.exports = __webpack_public_path__ + "static/rick-005-1a100e792256653012bd62916472085c.jpg";